import { html } from "lit-html"

const inactiveCls =
  "border-white bg-white text-gray-interactive hover:text-black"
const activeCls = "border-yellow bg-[#fffef5] text-black"

const SegmentedControl = ({ section, items, activeValue, onChange }) => html`
  ${items && items.length > 1
    ? html`
        <div data-section="${section}" class="mb-6 flex items-center">
          ${items.map(
            ({ value, label }) => html`
              <button
                class="flex items-center justify-center border-b-2 px-6 py-5 ${activeValue ===
                value
                  ? activeCls
                  : inactiveCls}"
                type="button"
                aria-pressed="${activeValue === value}"
                @click=${() => (activeValue === value ? null : onChange(value))}
              >
                ${label}
              </button>
            `
          )}
        </div>
      `
    : ``}
`

export default SegmentedControl
